import React from "react";
import { useLang } from "../lib/LangContext";

// Self-hosted brand asset (source: brand.ariovis.fr, mirrored to avoid hash-URL churn).
const LOGO_WHITE = `${process.env.PUBLIC_URL || ""}/logos/ariovis-logo-dark.svg`;

export default function Footer() {
  const { lang } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="ariovis-footer">
      <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <img src={LOGO_WHITE} alt="Ariovis" className="h-6" />
          <div className="text-sm text-slate-400">Security Meets Business</div>
        </div>
        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm" aria-label="Footer">
          <a href="https://www.ariovis.fr/produits" target="_blank" rel="noopener noreferrer" className="hover:text-white" data-testid="footer-link-products">
            {lang === "en" ? "Ariovis Products" : "Produits Ariovis"}
          </a>
          <a href="https://www.ariovis.fr" target="_blank" rel="noopener noreferrer" className="hover:text-white" data-testid="footer-link-ariovis">
            ariovis.fr
          </a>
          <a href="mailto:contact@ariovis.fr" className="hover:text-white" data-testid="footer-link-contact">
            contact@ariovis.fr
          </a>
        </nav>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-slate-500">
          <div>© {year} Ariovis. {lang === "en" ? "All rights reserved." : "Tous droits réservés."}</div>
          <div>
            {lang === "en"
              ? "Indicative study — does not replace an in-depth audit."
              : "Étude indicative — ne se substitue pas à un audit approfondi."}
          </div>
        </div>
      </div>
    </footer>
  );
}
